"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
// TODO: Make sure the tracking payloads are statically typed.
// TODO: Change these to be mapped to branded types so that the names are not exposed.
exports.Events = Object.freeze({
    pageNextClick: 1,
    pagePrevClick: 2,
    performerItemClick: 3,
    autocompleteResultClick: 7,
    pageNumClick: 8,
    filterClick: 10,
    sessionAction: 11,
});
//# sourceMappingURL=Events.js.map